import { render, staticRenderFns } from "./TaskTypesForm.vue?vue&type=template&id=1bb7f3b8"
import script from "./TaskTypesForm.vue?vue&type=script&lang=js"
export * from "./TaskTypesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports